<template>
  <div>
    <div :style="`width:`+chWidth+`; height:`+chHeight">
      <div v-if="isLoading" class="text-center pt-3"><img :alt="$t('loading')" :src="loadingUrl"> Načítavam ...</div>
      <div class="error m-1" v-if="errorMsg !== ''" v-html="errorMsg"></div>
      <template v-if="notEmptyObject(stationDataForChart) && !isLoading">
        <template v-if="emptyValueArray">
          <div class="error p-1 ml-1 mr-1" v-if="emptyValueArray">Údaje nie sú dostupné</div>
        </template>
        <template v-else>
          <highcharts ref="vtHighcharts" :updateArgs="[true, true, false]" :options="chartOptions"></highcharts>
        </template>

      </template>


    </div>

    <template v-if="notEmptyObject(stationDataForChart) && !isLoading && chartType==='sub'">
      <KoPollutantsSubTable :selected-pollutant-id="selectedPollutantId" :loaded-data="stationDataForChart" :loaded-data-extra="stationExtraDataForChart"></KoPollutantsSubTable>
    </template>
  </div>
</template>

<script>

import Axios from "axios";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';
import shmuMixin from "../mixin";
// import vtChart from './ko-detail-chart-options'
import SHMUconf from "../shmu_conf";
import KoPollutantsSubTable from "@/components/KoPollutantsSubTable";

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: true
  }
});
export default {
  components: {
    highcharts: Chart,
    KoPollutantsSubTable
  },
  name: 'KoChart',
  props: [
    'stationIdForChart',
    'selectedPollutantId',
    'chartType',
    'chartData',
  ],
  mixins: [
    shmuMixin,
  ],
  data() {
    return {
      errorMsg: '',
      historyHours: 168,
      isChartDataLoaded: false,
      isLoading: false,
      stationMeta: {},
      stationDataForChart: {},
      stationExtraDataForChart: {},
      stationPollutants: [],
      routedPollutantId: null,
      emptyValueArray: false,
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      latestStationIdForChart: 0,
      latestSelectedPollutant: 0,
      chWidth: '450px',
      chHeight: '150px',
      minX: 0,
      maxX: 0,
      chartOptions: {
        legend: {
          layout: 'horizontal', align: 'left', verticalAlign: 'top',
          enabled: false,
          useHTML: true,

        },
        credits: {
          enabled: false
        },
        chart: {
          type: 'spline',
          animation: false,
          height: '150px',
          margin: [33, 30, 33, 13]
        },
        title: {
          text: null,
          useHTML: true,
          style: {"color": "#000", "fontSize": "11px"},
        },
        subtitle: {
          text: null,
          useHTML: true,
          style: {"color": "#888", "fontSize": "9px"},
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
          },
          gridLineWidth: 1,
          gridLineColor: 'rgba(200,200,200,0.3)',
          lineColor: '#000',
          lineWidth: 1,
          tickColor: '#000',
          tickLength: 5,

          tickInterval: 12 * 60 * 60 * 1000,

          minorGridLineColor: 'rgba(8,8,8,0.3)',
          gridLineDashStyle: 'Dot',

          labels: {
            rotation: 45,
            y: 10,
            style: {"color": "#000", "fontSize": "9px"},

          },
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,


        },
        yAxis: [{
          min: 0,
          opposite: true,
          // max: max_y,

          title: {
            enabled: false,
          },

          minorTickInterval: 50,
          minorGridLineWidth: 1,
          minorGridLineColor: 'rgba(200,200,200,0.1)',
          gridLineColor: 'rgba(200,200,200,0.2)',

          lineColor: '#000',
          lineWidth: 1,
          tickWidth: 1,
          tickLength: 5,
          //tickInterval: 100,
          tickColor: '#000',
          plotBands: [],
          plotLines: [],
          labels: {
            x: 10,
            style: {"color": "#000", "fontSize": "9px"},

          },

        },
          {
            title: {
              enabled: false,
            },
          }],
        tooltip: {enabled: false, shared: true, useHTML: true},
        plotOptions: {
          spline: {
            showInLegend: true,
            animation: false,
            events: {
              legendItemClick: function () {
                return false;
              }
            },
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: false,
                  lineWidthPlus: 2
                }
              }
            },
            states: {
              hover: {
                enabled: false,
                lineWidthPlus: 0
              }
            }
          },
          scatter: {
            showInLegend: true,
            animation: false,
            events: {
              legendItemClick: function () {
                return false;
              }
            },
            tooltip: {
              pointFormatter: function () {
                var point = this;
                return '<small>' + Highcharts.dateFormat('%e. %B %Y', new Date(point.x)) + '</small>: <b>' + point.y + ' µg/m<sup>3</sup></b>';
              },
              shared: false,
            },
            states: {hover: {enabled: false}},
            marker: {
              symbol: 'circle',
              fillOpacity: 0.8,
              lineColor: '#000000',
              lineWidth: 0.5,
              radius: 6,
              states: {hover: {enabled: false}}
            },
          },
          states: {
            hover: {
              enabled: true
            }
          },
          series: {
            animation: false,
            states: {
              inactive: {
                opacity: 1
              }
            },

          }
        },
        series: [
          {
            id: 'm',
            name: 'Koncentrácia',
            type: 'spline',
            zIndex: 3,
            color: '#ff6c00',
            lineWidth: 2,
            tooltip: {valueSuffix: ' &micro;g/m<sup>3</sup>'},
            data: []
          },
          {
            id: 'pm10_12h',
            name: '12-h kĺzavý priemer PM<sub>10</sub>',
            type: 'spline',
            zIndex: 2,
            color: '#6A9FF6',
            lineWidth: 2,
            tooltip: {valueSuffix: ' &micro;g/m<sup>3</sup>'},
            data: []
          },
          {
            id: 'pm10_dpr',
            name: 'Denný priemer PM<sub>10</sub>',
            type: 'scatter',
            zIndex: 1,
            color: '#bbbbbb',
            tooltip: {valueSuffix: ' &micro;g/m<sup>3</sup>', enabled: false},
            data: [],
          }
        ]

      }
    }
  },
  watch: {
    stationIdForChart(v) {
      if (v !== this.latestStationIdForChart) {
        if (!this.chartData) {
          this.loadHistoryData(this.stationIdForChart);
        } else {
          this.processPropData();
        }
        this.latestStationIdForChart = v;
      }
    },
    selectedPollutantId(v) {
      if (v !== this.latestSelectedPollutant) {
        if (!this.chartData) {
          this.loadHistoryData(this.stationIdForChart);
        } else {
          this.processPropData();
        }
        this.latestSelectedPollutant = v;
      }
    }

  },


  mounted() {
    if (!this.chartData) {
      this.loadHistoryData(this.stationIdForChart);
    } else {
      this.processPropData();
    }

    if (this.chartType === 'sub') {
      this.chWidth = '100%';
      this.chHeight = '400px';
      this.chartOptions.chart.height = '400px';
      this.chartOptions.chart.margin = [50,50,50,20];
      this.chartOptions.tooltip.enabled = true;
      this.chartOptions.plotOptions.spline.marker.enabled = true;
      this.chartOptions.plotOptions.spline.marker.states.hover.enabled = true;
      this.chartOptions.plotOptions.spline.states.hover.enabled = true;
      this.chartOptions.plotOptions.scatter.marker.radius = 10;
      this.chartOptions.title.style.fontSize = '16px';
      this.chartOptions.xAxis.labels.style.fontSize = '12px';
      this.chartOptions.yAxis[0].labels.style.fontSize = '12px';
    }





  },
  destroy() {
    this.stationDataForChart = {};
    this.stationExtraDataForChart = {};
    this.isChartDataLoaded = false;
  },

  computed: {

  },
  methods: {

    processPropData() {
      const self = this;
      let r_data = this.chartData;
      self.stationMeta = r_data.station;
      self.pageTitle = self.stationMeta.station_name + ' - Aktuálne koncentrácie';
      self.stationPollutants = self.stationMeta.pollutants;
      self.stationDataForChart = r_data.data;
      self.stationExtraDataForChart = r_data.extra_data;
      self.isChartDataLoaded = true;
      self.generateChart();


    },

    loadHistoryData(station_id) {
      const self = this;

      self.isChartDataLoaded = false;
      self.isLoading = true;
      self.errorMsg = '';
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getdata?station='+station_id+'&history='+self.historyHours+'&station_meta=1', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              let r_data = response.data[0];
              self.stationMeta = r_data.station;
              self.pageTitle = self.stationMeta.station_name + ' - Aktuálne koncentrácie';
              self.stationPollutants = self.stationMeta.pollutants;
              self.stationDataForChart = r_data.data;
              self.stationExtraDataForChart = r_data.extra_data;
              self.isChartDataLoaded = true;
              self.generateChart();
            } else {
              // console.log('Response:', response);
              let errors = response.data.error.reduce((acc, item) => { acc.push(item.text); return acc; }, []);
              self.errorMsg = errors.join('<br>');
            }
            self.isLoading = false;

          }).catch((error) => {
        console.log('Err:', error);
        self.isLoading = false;
        self.errorMsg = 'Nepodarilo sa nadviazať spojenie so serverom SHMÚ';
      });

    },

    replacePollutantDesc: function(desc) {
      switch (desc) {
        case 'PM10': return 'PM<sub>10</sub>';
        case 'PM2.5': return 'PM<sub>2.5</sub>';
        case 'NO2': return 'NO<sub>2</sub>';
        case 'NOX': return 'NO<sub>X</sub>';
        case 'O3': return 'O<sub>3</sub>';
        case 'SO2': return 'SO<sub>2</sub>';
        default: return desc;
      }
    },
    generateChart() {
      // console.log(e);
      const self = this;

      let measured = [];
      let dpr_pm10 = [];
      let pm10_12h = [];
      let vals = [];
      let dts = [];


      // priprav data pre chart
      if (this.stationDataForChart && this.stationDataForChart.length > 0) {

        let pollutantData = this.stationDataForChart.filter(obj => {
          return obj.pollutant_id === self.selectedPollutantId;
        })

        if (pollutantData && pollutantData.length > 0) {

          pollutantData.sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0));

          let pollutantData_sliced = pollutantData.slice(-self.historyHours);

          pollutantData_sliced.every((item, index) => {
            /*
            if (item.value === 'PDL') {
              item.value = 0;
            }
             */

            if (index > self.historyHours) return false;

            // donutenie ho zobrazovat SEC/LSEC casy na grafe
            let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
            let m = this.$moment(m_f);
            let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

            //measured.push([item.dt * 1000, item.value]);
            let val = item.value;
            if (val === 'PDL') val = 0;
            measured.push([d, val]);

            dts.push(item.dt);

            if (item.value !== null) {
              vals.push(val);
            }

            return true;

          });

          if (vals.length > 0) {
            this.emptyValueArray = false;
          } else {
            this.emptyValueArray = true;
          }


        } else {
          this.emptyValueArray = true;
        }
      }


      let max_value = 0;
      let min_value = 0;
      let min_dt = 0;
      let max_dt = 0;

      if (dts.length > 0) {
        min_dt = Math.min.apply(null, dts);
        max_dt = Math.max.apply(null, dts);
      }

      // MIN MAX VALUES
      if (vals.length > 0) {
        min_value = Math.min.apply(null, vals);
        max_value = Math.max.apply(null, vals);

        if (max_value > 0) {
          max_value += Math.round((max_value * 0.2));
        } else {
          max_value += Math.round((Math.abs(max_value) * 0.2));
        }
        if (min_value < 0) {
          min_value -= Math.round((Math.abs(min_value) * 0.2));
        } else {
          min_value = 0;
        }
      }

      let max_value_check = 0;
      let minor_tick = 5;
      let normal_tick = 10;
      if (min_value < 0) max_value_check = Math.abs(min_value);
      else max_value_check = max_value;

      if (max_value_check > 500) { minor_tick = 50; normal_tick = 100; }
      else if (max_value_check > 200) { minor_tick = 10; normal_tick = 50; }
      else if (max_value_check > 50) { minor_tick = 5; normal_tick = 10; }
      else if (max_value_check > 0) { minor_tick = 1; normal_tick = 5; }

      this.chartOptions.yAxis[0].min = min_value;
      this.chartOptions.yAxis[0].max = max_value;
      this.chartOptions.yAxis[0].normalTick = normal_tick;
      this.chartOptions.yAxis[0].minorTick = minor_tick;

      let min_dt_f_ts = this.$moment.unix(min_dt).tz('Europe/Bratislava').utc().format();
      let min_dt_f = this.$moment(min_dt_f_ts);
      let min_dt_d = Date.UTC(min_dt_f.year(), min_dt_f.month(), min_dt_f.date(), min_dt_f.hours(), min_dt_f.minutes(), min_dt_f.seconds());

      let max_dt_f_ts = this.$moment.unix(max_dt).tz('Europe/Bratislava').utc().format();
      let max_dt_f = this.$moment(max_dt_f_ts);
      let max_dt_d = Date.UTC(max_dt_f.year(), max_dt_f.month(), max_dt_f.date(), max_dt_f.hours(), max_dt_f.minutes(), max_dt_f.seconds());


      this.chartOptions.xAxis.min = min_dt_d;
      this.chartOptions.xAxis.max = max_dt_d;

      //E:MIN MAX
      let pollutant = this.stationPollutants.find(obj => {
        return obj.pollutant_id === self.selectedPollutantId
      })


      // AK je vybrany PM10, rieime aj DPR PM10 a PM10-12H

      let dpr_pm10_serie = this.chartOptions.series.find(item => (item.id) === 'pm10_dpr');
      let pm10_12h_serie = this.chartOptions.series.find(item => (item.id) === 'pm10_12h');


      if (self.selectedPollutantId === 't24001') {
        let pollutantDataPM10_DPR = this.stationExtraDataForChart.filter(obj => {
          return obj.extra_pollutant_id === 'DPR_PM10';
        });

        let pollutantDataPM10_12H = this.stationExtraDataForChart.filter(obj => {
          return obj.extra_pollutant_id === 'PM10_12H';
        });

        //console.log(pollutantDataPM10_DPR, pollutantDataPM10_12H);

        pollutantDataPM10_DPR.sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0));
        pollutantDataPM10_DPR.forEach((item) => {
          if (item.value_avg === 'PDL') {
            item.value_avg = null;
          }
          if (item.dt < min_dt) return;

          // donutenie ho zobrazovat SEC/LSEC casy na grafe
          let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
          let m = this.$moment(m_f);
          let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

          //dpr_pm10.push([item.dt * 1000, item.value_avg]);
          dpr_pm10.push([d, item.value_avg]);


        });

        pollutantDataPM10_12H.sort((a,b) => (a.dt > b.dt) ? 1 : ((b.dt > a.dt) ? -1 : 0));
        pollutantDataPM10_12H.forEach((item) => {
          if (item.value === 'PDL') {
            item.value = null;
          }

          // donutenie ho zobrazovat SEC/LSEC casy na grafe
          let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
          let m = this.$moment(m_f);
          let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

          //pm10_12h.push([item.dt * 1000, item.value]);
          pm10_12h.push([d, item.value]);




        });

        dpr_pm10_serie.data = dpr_pm10;
        pm10_12h_serie.data = pm10_12h;

        if (this.chartType === 'sub') {
          this.chartOptions.legend.enabled = true;
        } else {
          this.chartOptions.legend.enabled = false;
        }

        this.chartOptions.yAxis[0].plotLines = [
          {zIndex:5, value: 50, color: 'rgba(255, 255, 0, 0.8)', dashStyle: 'shortdash',
            width:2, label:{useHTML:true,style:{fontSize:'9px'},text:'50&micro;g/m<sup>3</sup>'}},
          {zIndex:5, value: 100, color: 'rgba(255, 100, 0, 0.8)', dashStyle: 'shortdash',
            width:2, label:{useHTML:true,style:{fontSize:'9px'},text:'100&micro;g/m<sup>3</sup>'}},
          {zIndex:5, value: 150, color: 'rgba(255, 0, 0, 0.8)', dashStyle: 'shortdash',
            width:2, label:{useHTML:true,style:{fontSize:'9px'},text:'150&micro;g/m<sup>3</sup>'}}
        ];


        // console.log(this.chartOptions);

      } else {
        dpr_pm10_serie.data = [];
        pm10_12h_serie.data = [];
        this.chartOptions.legend.enabled = false;

        this.chartOptions.yAxis[0].plotLines = [];

      }



      let m1 = this.chartOptions.series.find(item => (item.id) === 'm');
      m1.data = measured;

      if (pollutant && pollutant.pollutant_id === 't85026') {
        m1.tooltip.valueSuffix = 'ng/m<sup>3</sup>';
      } else {
        m1.tooltip.valueSuffix = '&micro;g/m<sup>3</sup>';
      }

      if (pollutant) {
        m1.name = '1-h koncentrácia ' + this.replacePollutantDesc(pollutant.pollutant_desc);
        this.chartOptions.subtitle.text = this.replacePollutantDesc(pollutant.pollutant_desc) + ' ('+m1.tooltip.valueSuffix+')';

      }
      // this.chartOptions.yAxis[0].title.text =  this.replacePollutantDesc(pollutant.pollutant_desc) + '('+m1.tooltip.valueSuffix+')';
      this.chartOptions.title.text = self.stationMeta.station_name;



    },

  },



}
</script>


<style lang="scss">


</style>
